<template>
  <div
    class="form-line mb-6 mt-2"
    :class="{ 'form-line--dark': isDarkMode }"
    v-if="item.datatype != 'nodisplay'"
  >
    <Help :article="'editor-line/' + item.datatype + '/' + item.label" />
    <div
      class="small-extra-bold d-flex"
      :for="item.id"
      v-if="item.label !== 'Paths'"
    >
      <div v-if="item.type !== 'bool'">{{ item.label }}</div>

      <v-spacer />
      <div
        class="d-flex align-center p2-extra-bold cyan--text pointer"
        v-if="item.template"
        @click="showTemplateTester"
        :data-template="value[item.handle]"
      >
        <div>TEMPLATE TESTER</div>
        <apio-icon
          class="ml-1"
          name="ui-new-window"
          lightModeColour="cyan"
          darkModeColour="cyan"
        />
      </div>

      <div
        class="d-flex align-center p2-extra-bold cyan--text pointer"
        v-if="item.datatype == 'javascript'"
        @click="showJavascriptTester"
        :data-template="value[item.handle]"
      >
        <div>JAVASCRIPT TESTER</div>
        <apio-icon
          class="ml-1"
          name="ui-new-window"
          lightModeColour="cyan"
          darkModeColour="cyan"
        />
      </div>
    </div>
    <v-tooltip
      bottom
      v-if="item.datatype === 'datapath'"
      :disabled="!value[item.handle]"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-on="on"
          v-bind="attrs"
          v-if="item.datatype === 'datapath'"
          @click="launchDataMapperDialog"
        >
          <apio-checkbox
            readonly
            :value="value[item.handle]"
            v-if="value && value[item.handle]"
            v-model="value[item.handle]"
            :checked="value[item.handle] ? true : false"
            ><span
              slot="checkbox-label"
              v-if="value && value[item.handle]"
              v-html="value[item.handle]"
            >
            </span
          ></apio-checkbox>
          <apio-checkbox readonly v-else></apio-checkbox>Data Mapper
        </v-btn>
      </template>
    </v-tooltip>

    <v-select
      dense
      outlined
      :id="item.id"
      class="flex-grow-1"
      v-else-if="item.datatype === 'step'"
      v-model="value[item.handle]"
      :items="steps"
      hide-details="auto"
      @input="$root.$emit('auto-save')"
    >
    </v-select>

    <v-autocomplete
      dense
      outlined
      v-else-if="item.kind === 'select'"
      class="flex-grow-1"
      :id="item.id"
      v-model="value[item.handle]"
      :items="getOpts(item.placeholder)"
      hide-details="auto"
      @input="onSelectChange(value, item)"
    >
    </v-autocomplete>

    <p class="small" v-else-if="item.handle=='cron'">{{explained}}
    <v-combobox
      dense
      outlined
      class="flex-grow-1"
      :id="item.id"
      v-model="value[item.handle]"
      :items="getOpts(item.placeholder)"
      hide-details="auto"
      @input="onSelectChange(value, item)"
    >
    </v-combobox></p>
    <v-combobox
      dense
      outlined
      v-else-if="item.html === 'combobox'"
      class="flex-grow-1"
      :id="item.id"
      v-model="value[item.handle]"
      :items="getOpts(item.placeholder)"
      hide-details="auto"
      @input="onSelectChange(value, item)"
    >
    </v-combobox>

    <EditCases
      v-else-if="item.html === 'cases'"
      class="flex-grow-1"
      v-model="value[item.handle]"
    />
    <vue-select
      v-else-if="item.datatype.startsWith('[]')"
      class="flex-grow-1"
      :id="item.id"
      :taggable="true"
      :placeholder="item.placeholder"
      :multiple="true"
      :options="[]"
      @tag="addTag"
      tag-placeholder="Add this"
      v-model="value[item.handle]"
      @input="$root.$emit('auto-save')"
    />

    <v-text-field
      hide-details="auto"
      dense
      outlined
      v-else-if="
        item.kind === 'input' &&
        (item.type === 'int' || dataTypeTest(value[item.handle]) === 'number')
      "
      class="flex-grow-1"
      :id="item.id"
      :placeholder="item.placeholder"
      type="number"
      v-model.number="value[item.handle]"
    />
    <Editor
      v-else-if="
        item.kind === 'input' &&
        (item.type === 'string' ||
          dataTypeTest(value[item.handle]) === 'string') &&
        item.datatype !== 'datapath'
      "
      class="flex-grow-1"
      :conf="item"
      :env="env"
      :id="item.id"
      :item="item"
      :placeholder="item.placeholder"
      height="1"
      type="text"
      v-model="value[item.handle]"
    />
    <Editor
      v-else-if="item.kind === 'textarea'"
      :conf="item"
      :env="env"
      class="flex-grow-1"
      :id="item.id"
      :textarea="true"
      :placeholder="item.placeholder"
      :datatype="item.datatype"
      v-model="value[item.handle]"
    />
    <v-text-field
      hide-details="auto"
      dense
      outlined
      v-else-if="item.kind === 'input' && item.type === 'float32'"
      class="flex-grow-1"
      :id="item.id"
      :placeholder="item.placeholder"
      type="number"
      v-model.number="value[item.handle]"
    />
    <apio-checkbox
      v-else-if="item.kind === 'input' && item.type === 'bool'"
      class="flex-grow-1"
      :id="item.id"
      :placeholder="item.placeholder"
      size="lg"
      switch
      type="checkbox"
      :value="value[item.handle]"
      v-model="value[item.handle]"
      ><div slot="checkbox-label" class="p2-normal">
        {{ item.label }}
      </div></apio-checkbox
    >
    <EditMap
      v-else-if="item.datatype === 'map'"
      class="flex-grow-1"
      :item="item"
      :conf="conf"
      v-model="value[item.handle]"
    />

    <v-dialog
      v-model="dataMapperDialog"
      class="datamapper"
      permanent
      fullscreen
    >
      <v-card flat>
        <v-card-text>
          <data-mapper :single-line="true" :viewSource="dataSource" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import cronstrue from 'cronstrue';

export default {
  name: "FormLine",
  components: {
    DataMapper: () => import("@/components/DataMapper/DataMapper.vue"),
    Editor: () => import("@/components/Editor.vue"),
    EditMap: () => import("@/components/Editor/EditMap.vue"),
    EditCases: () => import("@/components/Editor/EditCases.vue"),
    Help: () => import("@/components/Help/Help.vue"),
  },
  props: {
    env: {},
    item: {},
    value: {
      required: true,
    },
    conf: {
      type: Object,
      required: false,
    },
    steps: {
      type: Array,
      required: false,
    },
    dataSource: {},
  },
  data() {
    return {
      dataMapperDialog: false,
    };
  },
  computed: {
    ...mapState({
      datamapper: (state) => state.datamapper,
    }),
    isDarkMode() {
      return this.$store.state.mode.darkMode;
    },
    explained() {
      if (this.value[this.item.handle]) {
        return cronstrue.toString(this.value[this.item.handle]);
      }
      return "";
    }
  },
  mounted() {
    this.$root.$on("closeDataMapper", () => {
      this.dataMapperDialog = false;
    });

    this.$root.$on("javascript-input", (payload) => {
      this.value[this.item.handle] = payload.v;
    })

    this.$root.$on("template-input", (payload) => {
      this.value[this.item.handle] = payload;
    })

    this.$store.subscribe((mutation) => {
      if (mutation.type === "UPDATE_DATAPATH" && mutation.payload) {
        if (this.item.handle === this.datamapper.selectedDatapath) {
          this.value[this.item.handle] = mutation.payload.selected;
        }
      }
    });

    this.setDefaultValue();
 },
  destroy() {
    this.$store.unsubscribe();
  },
  methods: {
    setDefaultValue() {
      if(this.value[this.item.handle]) return;
      let defaultVal = this.item.default;
      if(!defaultVal) return;
      switch (this.item.type) {
        case 'int':
          this.value[this.item.handle] = parseInt(defaultVal);
          return;
        case 'float32':
          this.value[this.item.handle] = parseFloat(defaultVal);
          return;
        case 'number':
          this.value[this.item.handle] = parseFloat(defaultVal);
          return;
        case 'bool':
          this.value[this.item.handle] === "true" ? true : false;
          return;
        default:
          return;
      }
    },
    dataTypeTest(value) {
      if (typeof value === "number") {
        this.item.type = "int";
      }
      return typeof value;
    },
    autoSave() {
      this.$root.$emit("auto-save");
    },
    launchDataMapperDialog() {
      this.$store.dispatch("updateSelectedDatapath", this.item.handle);
      this.dataMapperDialog = true;
    },
    showTemplateTester() {
      this.$root.$emit("show-template-tester", { value: this.value[this.item.handle], handle: this.item.handle });
    },
    showJavascriptTester() {
      this.$root.$emit("show-javascript-tester", { value: this.value[this.item.handle]});
    },
    showConditionTester() {
      this.$root.$emit("show-condition-tester");
    },
    getOpts(s) {
      if (typeof s == "undefined") {
        return ["no options defined"];
      }
      return s.replace("[", "").replace("]", "").split(",");
    },
    addTag(newvalue) {
      this.$store.dispatch("addTag", newvalue);
      this.value[this.item.handle].push(newvalue);
    },
    onSelectChange(value) {
      if (value.format.length) {
        this.$root.$emit("auto-save");
        this.$root.$emit("update-editor-form");
      }
    },
  },
};
</script>
<style scoped lang="scss">
.pointer {
  cursor: pointer;
}

.form-line {
  color: var(--apio-shade-2);

  &--dark {
    color: var(--apio-shade-4);
  }
}

::v-deep .v-dialog--fullscreen {
  overflow-y: hidden;
}

input,
textarea,
input:focus,
textarea:focus {
  background-color: #ccc;
  color: black;
  border: none;
  border-radius: 0;
}

::placeholder {
  color: grey;
}

:-ms-input-placeholder {
  color: grey;
}

::-ms-input-placeholder {
  color: grey;
}
</style>
